import React from "react";
import PropTypes from "prop-types";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import PersonIcon from "@material-ui/icons/Person";
import "./MenuButton.css";

// メニュー用のボタン
function MenuButton(props) {
  const { buttonLabel, topSubLabel, underSubLabel, isPerson, onClick } = props;

  return (
    <div className="menu-button" onClick={onClick || MenuButton.defaultOnClick}>
      <div className="label-area">
        {topSubLabel && <div className="top-sub-label">{topSubLabel}</div>}
        <div className="main-label">
          {isPerson && <PersonIcon className="icon" data-testid="PersonIcon" />}
          {buttonLabel}
        </div>
        {underSubLabel && (
          <div className="under-sub-label">{underSubLabel}</div>
        )}
      </div>
      <div className="icon-area">
        <KeyboardArrowRightIcon
          className="icon"
          data-testid="KeyboardArrowRightIcon"
        />
      </div>
    </div>
  );
}

// デフォルトの onClick ハンドラ
MenuButton.defaultOnClick = () => {};

// PropTypesを使ってプロパティの型を定義
MenuButton.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  topSubLabel: PropTypes.string,
  underSubLabel: PropTypes.string,
  isPerson: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MenuButton;
